import { authenticatedPost } from '../utils/apiUtils';
import { BASE_URL } from '../api-config';

/**
 * Send push notification to a specific user
 * @param {string} userId - The target user ID
 * @param {string} title - Notification title
 * @param {string} body - Notification body
 * @param {object} data - Optional data payload
 * @returns {Promise<object>} Response with success status and devices count
 */
export const sendPushNotification = async (userId, title, body, data = null) => {
  const url = `${BASE_URL}/push/send-notification`;
  const payload = {
    user_id: userId,
    title,
    body,
    ...(data && { data })
  };

  console.log('Push notification URL:', url);
  console.log('Push notification payload:', payload);

  return await authenticatedPost(url, payload);
};